import { timelineBars } from '@/audio/clipTiming';

const EPS = 1e-6;

/** Phrase-sized steps: an 8-bar copy moves in 8s, 4-bar in 4s, 2-bar in 2s, anything shorter in bars. */
export const pasteStep = (spanBars) => [8, 4, 2].find((step) => spanBars >= step - EPS) || 1;

const overlaps = (aStart, aEnd, bStart, bEnd) => aStart < bEnd - EPS && bStart < aEnd - EPS;

/** True when every item lands on empty space on its own track. */
export function fitsAt(tracks, items, baseBar, bpm) {
  return items.every((item) => {
    const track = tracks.find((t) => t.id === item.trackId);
    if (!track) return true;
    const start = baseBar + (item.relativeOffset || 0);
    const end = start + timelineBars(item.clip, bpm);
    return !(track.clips || []).some((clip) => {
      const clipStart = Number(clip.start_bar || 0);
      return overlaps(start, end, clipStart, clipStart + timelineBars(clip, bpm));
    });
  });
}

/**
 * Where a paste (or duplicate) goes: exactly at `desiredBar` when that space is empty on every
 * target track, otherwise the next empty phrase boundary after it. Returns null when nothing fits
 * before `maxBars`, so the caller can say so instead of hiding clips past the song's limit.
 */
export function findPasteBar({ tracks, items, desiredBar, span, bpm, maxBars, step: requestedStep }) {
  const step = Number(requestedStep) > 0 ? Number(requestedStep) : pasteStep(span);
  const fitsInSong = (base) => base + span <= maxBars + EPS;
  const desired = Math.max(0, desiredBar);
  if (fitsInSong(desired) && fitsAt(tracks, items, desired, bpm)) return desired;
  for (let base = Math.ceil((desired + EPS) / step) * step; fitsInSong(base); base += step) {
    if (fitsAt(tracks, items, base, bpm)) return base;
  }
  return null;
}
